module.exports = __webpack_public_path__ + "static/media/8.919d3aa0.jpg";